export default __webpack_public_path__ + "static/media/pause.e3fdb852.svg";